import React, { createContext, useContext, useState, useCallback } from 'react';
import axios from 'axios';
import api from '../services/api';

const DeveloperContext = createContext();

export const DeveloperProvider = ({ children }) => {
  const [developers, setDevelopers] = useState([]);
  const [developerData, setDeveloperData] = useState(null);

  const fetchDevelopers = useCallback(async () => {
    try {
      const response = await api.get(`/lms/developers/`);
      setDevelopers(response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching developers:', error);
      throw error;
    }
  }, []);

  const getDeveloperById = useCallback(async (developerId) => {
    try {
      const response = await api.get(`/lms/developers/${developerId}/`);
      setDeveloperData(response.data);
      return response.data;
    } catch (error) {
      console.error(`Error fetching developer ${developerId}:`, error);
      throw error;
    }
  }, []);

  const createDeveloper = useCallback(async (developerData) => {
    try {
      // Check if developerData is FormData (file upload) or regular object
      const config = developerData instanceof FormData ? {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      } : {};
      
      const response = await api.post(`/lms/developers/`, developerData, config);
      setDevelopers(prev => [...prev, response.data]);
      setDeveloperData(response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating developer:', error);
      throw error;
    }
  }, []);

  const updateDeveloper = useCallback(async (developerId, developerData) => {
    try {
      // Check if developerData is FormData (file upload) or regular object
      const config = developerData instanceof FormData ? {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      } : {};
      
      const response = await api.put(`/lms/developers/${developerId}/`, developerData, config);
      setDevelopers(prev => prev.map(dev => 
        dev.id === developerId ? response.data : dev
      ));
      return response.data;
    } catch (error) {
      console.error(`Error updating developer ${developerId}:`, error);
      throw error;
    }
  }, []);

  const deleteDeveloper = useCallback(async (developerId) => {
    try {
      await api.delete(`/lms/developers/${developerId}/`);
      setDevelopers(prev => prev.filter(dev => dev.id !== developerId));
    } catch (error) {
      console.error(`Error deleting developer ${developerId}:`, error);
      throw error;
    }
  }, []);

  return (
    <DeveloperContext.Provider value={{
      developers,
      setDevelopers,
      fetchDevelopers,
      getDeveloperById,
      createDeveloper,
      updateDeveloper,
      deleteDeveloper
    }}>
      {children}
    </DeveloperContext.Provider>
  );
};

export const useDevelopers = () => useContext(DeveloperContext);
